import * as React from "react";

import Checkbox from "@components/UI/Checkbox";

const CustomCheckbox = (props) => {
  const { input, defaultMessage, testId } = props;
  const { onChange, checked } = input;

  return (
    <div className="custom-checkbox-container">
      <Checkbox
        onClick={() => onChange(!checked)}
        checked={checked}
        label={defaultMessage}
        customContainerClass="custom-checkbox"
        id={testId}
      />
    </div>
  );
};

export default CustomCheckbox;
